import axios from "axios";
import {initialCancelFunction} from "../../../../util/Helpers"

const cancelToken = axios.CancelToken;
let cancelSearchUserReq = initialCancelFunction;

export const USERS_URL = "/users";

// CREATE =>  POST: add a new user to the server
export function addUser(userData) {
  return axios.post(USERS_URL, {...userData});
}

// READ
export function getAllUsers() {
  return axios.get(USERS_URL);
}

// READ
export function getSearchUsers(query) {
  cancelSearchUserReq("Cancel Request");
  return axios.get(`${USERS_URL}?query=${query}`, {
      cancelToken: new cancelToken(function executor(cancel) {
        // An executor function receives a cancel function as a parameter
        cancelSearchUserReq = cancel;
      })
    }
  );
}

// UPDATE => PUT: update the user on the server
export function updateUser(userData) {
  return axios.put(`${USERS_URL}/${userData.id}`, { ...userData });
}

// DELETE => delete the user from the server
export function deleteUser(userId) {
  return axios.delete(`${USERS_URL}/${userId}`);
}

